export type Role='owner'|'admin'|'operator'|'editor'|'reviewer'|'publisher'|'viewer';
export type Page<T>={items:T[];page:number;pageSize:number;total:number};
export type Principal={workspaceId:string;userId:string;role:Role;authType:string};

const devHeaders=():Record<string,string>=>localStorage.getItem('workspaceId')?{
  'x-dev-secret':localStorage.getItem('devSecret')||'',
  'x-workspace-id':localStorage.getItem('workspaceId')||'',
  'x-user-id':localStorage.getItem('userId')||'',
  'x-role':localStorage.getItem('role')||'owner',
}:{};

export class ApiError extends Error{constructor(public status:number,public code:string,public requestId?:string){super(code)}}
type ApiInit=Omit<RequestInit,'body'|'headers'>&{body?:unknown;headers?:Record<string,string>};
export async function api<T=unknown>(path:string,init:ApiInit={}):Promise<T>{
  const body=init.body===undefined?undefined:JSON.stringify(init.body);
  const {body:_body,...options}=init;
  const response=await fetch(path,{...options,credentials:'same-origin',body,headers:{...devHeaders(),...(body?{'content-type':'application/json'}:{}),...init.headers}});
  const json=response.headers.get('content-type')?.includes('json');
  const data=json?await response.json():await response.text();
  if(!response.ok)throw new ApiError(response.status,data?.error||`HTTP ${response.status}`,data?.requestId);
  return data as T;
}
export async function bootstrapDev(){
  const response=await fetch('/auth/dev-bootstrap');
  if(!response.ok||localStorage.getItem('workspaceId'))return;
  const x=await response.json();
  Object.entries({workspaceId:x.workspaceId,userId:x.userId,devSecret:x.devSecret,role:x.role}).forEach(([k,v])=>localStorage.setItem(k,String(v)));
}
export async function streamEvents(runId:string,onEvent:(event:{id:number;type:string;payload:unknown})=>void,signal:AbortSignal){
  let cursor=0;
  while(!signal.aborted){
    try{
      const response=await fetch(`/v1/runs/${runId}/events?stream=1`,{headers:{...devHeaders(),Accept:'text/event-stream','Last-Event-ID':String(cursor)},signal});
      if(!response.ok||!response.body)throw new Error(`SSE ${response.status}`);
      const reader=response.body.getReader(),decoder=new TextDecoder();let buffer='';
      while(!signal.aborted){const {done,value}=await reader.read();if(done)break;buffer+=decoder.decode(value,{stream:true});const blocks=buffer.split('\n\n');buffer=blocks.pop()||'';for(const block of blocks){const id=Number(/^id: (.+)$/m.exec(block)?.[1]);const type=/^event: (.+)$/m.exec(block)?.[1];const raw=/^data: (.+)$/m.exec(block)?.[1];if(id&&type&&raw){cursor=id;onEvent({id,type,payload:JSON.parse(raw)})}}}
    }catch(error){if(signal.aborted)return;await new Promise(resolve=>setTimeout(resolve,1200));}
  }
}
